@if (!isImpersonating) {
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>{{'admin.users.list'|traduccion}}</mat-panel-title>
      </mat-expansion-panel-header>
      <!-- Buscador -->
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>{{'admin.users.search'|traduccion}}</mat-label>
        <input matInput (keyup)="applyFilter($event)" [placeholder]="'admin.users.searchPlaceholder'|traduccion">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <!-- Tabla -->
      <div class="mat-elevation-z4 table-container">
        <table mat-table [dataSource]="dataSource" class="full-width-table">
          <!-- Username -->
          <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef>{{'admin.users.username'|traduccion}}</th>
            <td mat-cell *matCellDef="let user"> {{user.username}} </td>
          </ng-container>
          <!-- Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>{{'admin.users.actions'|traduccion}}</th>
            <td mat-cell *matCellDef="let user">
              <button mat-button color="primary"
                (click)="loginAs(user.username)"
                [disabled]="isImpersonating">
                {{'admin.users.loginAs'|traduccion}}
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
}

<!-- Botón flotante para volver
<!--
<button *ngIf="isImpersonating"
  mat-fab
  color="accent"
  class="fab-stop"
  (click)="stop()">
  <mat-icon>logout</mat-icon>
</button>
-->

<!-- Banner de aviso -->
@if (isImpersonating) {
  <mat-toolbar color="warn">
    <span>⚠ {{'admin.users.actingAs'|traduccion}} <b>{{ impersonatedUser }}</b></span>
    <span class="spacer"></span>
    <button mat-button (click)="stop()">{{'admin.users.back'|traduccion}}</button>
  </mat-toolbar>
}
